<ion-toggle [(ngModel)]="isToggleChecked" (ngModelChange)="toggleTheme()"></ion-toggle>
